<template>
  <div>
    <el-form ref="form" :model="form" label-width="130px" size="small">
      <slot name="form-item-process-name" :model="form" field="name">
        <el-form-item label="流程定义名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-displayName" :model="form" field="displayName">
        <el-form-item label="流程定义显示名称">
          <el-input v-model="form.displayName"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-expireTime" :model="form" field="expireTime">
        <el-form-item label="期望完成时间">
          <el-input v-model="form.expireTime"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-instanceUrl" :model="form" field="instanceUrl">
        <el-form-item label="实例启动Url">
          <el-input v-model="form.instanceUrl"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-instanceNoClass" :model="form" field="instanceNoClass">
        <el-form-item label="实例编号生成类">
          <el-input v-model="form.instanceNoClass"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-preInterceptors" :model="form" field="preInterceptors">
        <el-form-item label="节点前置拦截器">
          <el-input v-model="form.preInterceptors"></el-input>
        </el-form-item>
      </slot>
      <slot name="form-item-process-postInterceptors" :model="form" field="postInterceptors">
        <el-form-item label="节点后置拦截器">
          <el-input v-model="form.postInterceptors"></el-input>
        </el-form-item>
      </slot>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.value
    }
  },
  watch: {
    form: {
      handler (n) {
        this.$emit('change', n)
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
